import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Bot, Sparkles } from 'lucide-react';
import { AIChat } from './ai-chat/AIChat';

export function AskDrogoBar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative"
      >
        <button
          onClick={() => setIsOpen(true)}
          className="w-full relative group overflow-hidden"
        >
          {/* Siri-like Glow Container */}
          <div className="relative p-[1px] rounded-lg">
            {/* Animated Border */}
            <div className="absolute inset-0 rounded-lg animate-siri-glow">
              <div className="absolute inset-0 bg-gradient-to-r from-primary/30 via-purple-500/30 to-primary/30 rounded-lg animate-border-flow" />
            </div>

            {/* Inner Content */}
            <div className="relative bg-background rounded-lg p-2">
              {/* Ambient Background */}
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-purple-500/5 to-transparent opacity-30" />
              
              {/* Content */}
              <div className="relative flex items-center gap-2">
                <div className="relative w-6 h-6 flex items-center justify-center">
                  <Bot className="w-4 h-4 text-primary relative z-10" />
                  <div className="absolute inset-0 animate-pulse bg-primary/50 blur-xl rounded-full"></div>
                  <div className="absolute inset-0 bg-primary/20 blur-md rounded-full"></div>
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/30 to-primary/30 animate-spin-slow rounded-full"></div>
                </div>
                <div className="flex-1 text-left">
                  <div className="text-xs font-medium flex items-center gap-1">
                    Ask Drogo
                    <span className="text-muted-foreground">•</span>
                    <span className="text-xs text-muted-foreground">AI Health Coach</span>
                  </div>
                </div>
                <div className="relative w-6 h-6 flex items-center justify-center">
                  <Sparkles className="w-3 h-3 text-primary relative z-10" />
                  <div className="absolute inset-0 animate-pulse bg-primary/50 blur-xl rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
        </button>
      </motion.div>

      <AIChat isOpen={isOpen} onOpenChange={setIsOpen} />
    </>
  );
}